module.exports = __webpack_public_path__ + "static/media/promanager.61968ce5.png";